import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Phase 117B — Register service worker so PWA install is eligible.
// The SW is intentionally minimal (network-first pass-through); its
// presence is what unlocks Chrome's `beforeinstallprompt` event.
// Registered in all environments (HMR uses WebSocket which the SW does
// not intercept) so the install flow can be QA'd on the preview pod.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      /* swallow — non-fatal, app keeps working in vanilla mode */
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
